import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import LearningReachedLevelRateTable from './LearningReachedLevelRateTable';
import { LevelAdvancementRateListService } from '../services/LearningListService';

class LearningReachedLevelRateTableContainer extends React.Component {
  constructor(props) {
    super(props);
    LevelAdvancementRateListService.load();
  }

  render() {
    return (
      <LearningReachedLevelRateTable
        loading={LevelAdvancementRateListService.fetch.fetching}
        values={toJS(LevelAdvancementRateListService.byCourse)}
        feedbackColorRender={LevelAdvancementRateListService.getFeedbackColor}
        formatter={LevelAdvancementRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(LearningReachedLevelRateTableContainer);
